import store from '../../../redux/store';
import { assetIcons, shapesIcon } from '../../../utils/constant';

function findReduxAsset(item) {
  if (!item) return null;

  try {
    const state = store.getState();
    const meshAssets = state.assets_object?.assets_data?.mesh || [];

    const itemIds = [
      item._id,
      item.id,
      item.name,
      item.url,
      item.temp_file_name,
      item.userData?.id,
      item.userData?._id,
    ].filter(Boolean);

    return meshAssets.find((asset) => {
      const assetIds = [
        asset._id,
        asset.id,
        asset.name,
        asset.url,
        asset.temp_file_name,
      ].filter(Boolean);
      return itemIds.some((id) => assetIds.includes(id));
    });
  } catch (error) {
    console.warn('Error querying Redux state in findReduxAsset:', error);
    return null;
  }
}

function extractShapeFromTempName(tempName) {
  if (!tempName || typeof tempName !== 'string') return null;
  if (!tempName.includes('temp')) return null;
  const lower = tempName.toLowerCase();
  for (const shape of Object.keys(shapesIcon)) {
    if (lower.includes(shape)) {
      return shape;
    }
  }
  return null;
}

function resolveShapeIconKey(item) {
  const reduxAsset = findReduxAsset(item);

  // 1. Check exact candidate shape_type or mesh_code keys
  const candidates = [
    reduxAsset?.shape_type,
    reduxAsset?.mesh_code,
    item?.shape_type,
    item?.mesh_code,
    item?.userData?.shape_type,
    item?.userData?.mesh_code,
  ];

  for (const value of candidates) {
    const key = String(value || '').trim().toLowerCase();
    if (key && shapesIcon[key]) return key;
  }

  // 2. Check temp_file_name or temp IDs (immutable identifiers that don't change on rename)
  const tempCandidates = [
    item?.temp_file_name,
    item?.userData?.temp_file_name,
    reduxAsset?.temp_file_name,
    item?._id,
    item?.id,
    reduxAsset?._id,
    reduxAsset?.id,
  ];

  for (const tempName of tempCandidates) {
    const shape = extractShapeFromTempName(tempName);
    if (shape) return shape;
  }

  // 3. Fallback to searching inside display names/file names
  const searchIn = String(
    item?.file_name || item?.asset_file_name || item?.name || ''
  )
    .toLowerCase()
    .replace(/\s+/g, '');

  for (const shape of Object.keys(shapesIcon)) {
    if (searchIn.includes(shape)) return shape;
  }

  return null;
}

export function getAssetIcon(item, arrKey) {
  const key = (arrKey || '').toLowerCase();

  let useKey = key;
  if (key === 'images' || key === 'img') useKey = 'image';
  if (key === 'meshes') useKey = 'mesh';
  if (key === 'videos') useKey = 'video';
  if (key === 'audios') useKey = 'audio';

  if (useKey === 'particle') {
    const particleType = item?.type || '';
    return assetIcons[particleType] || assetIcons.particle;
  }
  if (useKey !== 'mesh') {
    return assetIcons[useKey] || assetIcons.default;
  }

  const shapeKey = resolveShapeIconKey(item);
  if (shapeKey) {
    return shapesIcon[shapeKey] || assetIcons.mesh;
  }

  if (item?.deleteType && assetIcons[item.deleteType]) {
    return assetIcons[item.deleteType];
  }

  return assetIcons.mesh;
}
